import { FC, useEffect } from 'react';
import SurveyDefaultStep from '@/components/SurveyDefaultStep';
import PayplaVenmoImage from '@/assets/images/paypal-venmo.png';
import useSurveyNavigate from '@/hooks/useSurveyNavigate';
import analytics from '@/utils/analytics/analyticsInstance';

const ConvertPage: FC = () => {
  const { next } = useSurveyNavigate();

  useEffect(() => {
    analytics.track('webOnboardingScreenOpened', {
      screen_title: 'Convert your rewards into real cash',
    });
  }, []);

  return (
    <SurveyDefaultStep
      title={{ value: 'Convert your rewards into real cash' }}
      subTitle={{ value: 'Redeem rewards via PayPal or Venmo' }}
      image={PayplaVenmoImage}
      button={{ onClick: next }}
    />
  );
};

export default ConvertPage;
